import React, {PureComponent} from 'react';

import LinkAs from '../LinkAs/LinkAs.jsx';

import {generate} from '../../routes.js';

import './GetMissions.scss';

export default class GetMissions extends PureComponent {
  render() {
    return <div id="get-missions">
      <section className="container text-center py-5">
        <h2 className="mb-4 text-white">
          Vous êtes à la recherche d'opportunités ?<br/>Twineeds est la fenêtre vers de nouvelles missions !
        </h2>
        <LinkAs
          className="btn btn-primary"
          notConnected={generate({name: 'register-freelance'})}
          freelance={generate({name: 'offers'})}
        >
          Recevoir des missions
        </LinkAs>
      </section>
    </div>;
  }
}
